import { useEffect } from "react";

let lockCount = 0;
let savedScrollY = 0;
let savedHtmlOverflow = "";
let savedBodyOverflow = "";
let savedBodyPosition = "";
let savedBodyTop = "";
let savedBodyWidth = "";

const applyLock = () => {
  const html = document.documentElement;
  const body = document.body;

  savedScrollY = window.scrollY || window.pageYOffset || 0;
  savedHtmlOverflow = html.style.overflow;
  savedBodyOverflow = body.style.overflow;
  savedBodyPosition = body.style.position;
  savedBodyTop = body.style.top;
  savedBodyWidth = body.style.width;

  html.style.overflow = "hidden";
  body.style.overflow = "hidden";
  body.style.position = "fixed";
  body.style.top = `-${savedScrollY}px`;
  body.style.width = "100%";
};

const releaseLock = () => {
  const html = document.documentElement;
  const body = document.body;

  html.style.overflow = savedHtmlOverflow;
  body.style.overflow = savedBodyOverflow;
  body.style.position = savedBodyPosition;
  body.style.top = savedBodyTop;
  body.style.width = savedBodyWidth;

  // Force instant — globalStyles sets scroll-behavior: smooth on *, which
  // would animate this restore and look like the page is scrolling from the
  // top back down to the user's prior position.
  window.scrollTo({ top: savedScrollY, left: 0, behavior: "instant" });
};

export function useLockBodyScroll(isLocked) {
  useEffect(() => {
    if (!isLocked) return undefined;

    lockCount += 1;
    if (lockCount === 1) applyLock();

    return () => {
      lockCount -= 1;
      if (lockCount === 0) releaseLock();
    };
  }, [isLocked]);
}
